module.exports = __webpack_public_path__ + "img/res7.f2834293.gif";